import { useState } from "react";
import AddProfilesGridModel from "../../../models/company/addProfiles/response/AddProfilesGridModel";
import IdNameModel from "../../../models/common/IdNameModel";
import addProfilesService from "../../../services/company/add-profiles-service";
import toasterUtils from "../../../utils/toaster-utils";
import InterviewRoundsPopUp from "./ScheduleInterviewRoundsComponent";
import ScheduleInterviewPopUp from "./ScheduleInterviewComponent";
import { GeneralPoupConfig, ModalSize } from "../../../models/modal-types";
import AddProfilesInterviewRoundsModel from "../../../models/company/addProfiles/response/AddProfilesInterviewRoundsModel";
import modalUtils from "../../../utils/modal-utils";
import ScheduleInterviewCompanyRequestModel from "../../../models/company/addProfiles/request/ScheduleInterviewCompanyRequestModel";
import { GuidEnum } from "../../../models/enums/GuidEnum";
import ScheduleInterviewRequest from "../../../models/candidate/request/ScheduleInterviewRequest";
import { InterviewTypeEnum } from "../../../models/enums/InterviewTypeEnum";
import { useAppSelector } from "../../../context-store";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import TableContainer from "@mui/material/TableContainer";
import TableSortLabel from "@mui/material/TableSortLabel";
import TableHead from "@mui/material/TableHead";
import copyClickboardUtils from "../../../utils/copy-clipboard";
import candidateService from "../../../services/candidate/candidate-service";
import fileUtils from "../../../utils/file-utils";
import { FileUploadTypeEnum } from "../../../models/enums/FileUploadTypeEnum";
import AddProfilesGridChildComponent from "./AddProfilesGridChildComponent";

interface AddProfilesGridProps {
    addProfilesList: AddProfilesGridModel[];
    requirementId: string;
    timeSlotsList: IdNameModel[];
    totalSize: number;
    currentPage: number;
    pagesize: number;
    sortColumn: string;
    sortDirection: "asc" | "desc";
    pageSizesList: number[];
    candidateNameFilterValue: string;
    statusIdFilterValue: number;
    canScheduleInterviews: boolean;
    onProfileAdd: (actionType: string) => void;
    onStatusUpdate: (row: AddProfilesGridModel) => void;
    onScheduleInterview: (row: ScheduleInterviewCompanyRequestModel) => void;
    onRatingDetails: (interviewId: string) => void;
    onCandidateViewHistory: (candidateId: string) => void;
    onPageChangeAction: (newPage: number) => void;
    onPageSizeChangeAction: (newPageSize: number) => void;
    onSortAction: (newSortColumn: string, sortDir: string) => void;
    onFilterAction: (filterColumn: string, filterValue: string) => void;
    onViewRatingAction: (interviewId: string) => void;
}

const AddProfilesGridComponent = (props: AddProfilesGridProps) => {
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    const [roleId, setRoleId] = useState<number>(loggedInUser !== null ? parseInt(loggedInUser.roleId) : 0);
    const [candidateNameFilter, setCandidateNameFilter] = useState<string>(props.candidateNameFilterValue);
    const [statusIdFilter, setStatusIdFilter] = useState<number>(props.statusIdFilterValue);

    const statusUpdate = (row: AddProfilesGridModel) => {
        props.onStatusUpdate(row);
    };

    const openInterviewRoundsModel = (interviewRounds: AddProfilesInterviewRoundsModel[], objAddProfile: AddProfilesGridModel) => {
        const config: GeneralPoupConfig = {
            title: "Schedule Interview Rounds",
            content: (
                <InterviewRoundsPopUp
                    objAddProfile={objAddProfile}
                    interviewRoundsList={interviewRounds}
                    onCloseInterviewRounds={onCloseInterviewRoundsHandler}
                    onInterviewRoundSelect={onInterviewRoundSelectHandler}
                    onInterviewRatingDetails={onInterviewRatingDetailsHandler}
                />
            ),
            size: ModalSize.LG,
            className: "model-min-height-500"
        };
        modalUtils.showPopup(config);
    };

    const onCloseInterviewRoundsHandler = () => {
        modalUtils.closeModal();
    };

    const onInterviewRoundSelectHandler = (objInterviewRound: AddProfilesInterviewRoundsModel, objAddProfile: AddProfilesGridModel) => {
        openScheduleInterviewModel(objInterviewRound, objAddProfile);
    };

    const onInterviewRatingDetailsHandler = (objInterviewRound: AddProfilesInterviewRoundsModel, objAddProfile: AddProfilesGridModel) => {
        props.onRatingDetails(objInterviewRound.interviewId);
    };

    const openScheduleInterviewModel = (objInterviewRound: AddProfilesInterviewRoundsModel, objAddProfile: AddProfilesGridModel) => {
        let scheduleInterview: ScheduleInterviewRequest = {
            candidateId: objAddProfile.candidateId,
            interviewDate: new Date(),
            interviewDateString: "",
            timeSlotId: 0,
            interviewTypeId: InterviewTypeEnum.Video,
            primarySkillId: 0,
            secondarySkills: [],
            termsAndConditions: true,
            requirementId: objAddProfile.requirementId,
            interviewId: objInterviewRound.interviewId
        };
        let objScheduleInterview: ScheduleInterviewCompanyRequestModel = {
            profileId: objAddProfile.profileId,
            userId: GuidEnum.Empty,
            requirementInterviewProcessId: objInterviewRound.requirementInterviewProcessId,
            requirementScheduleId: objInterviewRound.requirementScheduleId,
            interviewId: objInterviewRound.interviewId,
            interviewerId: null,
            scheduleInterviewRequestModel: scheduleInterview
        }
        const config: GeneralPoupConfig = {
            title: objInterviewRound.interviewId === null ? "Schedule Interview" : "Re Schedule Interview",
            content: (
                <ScheduleInterviewPopUp
                    objScheduleInterview={objScheduleInterview}
                    timeSlotsList={props.timeSlotsList}
                    onCloseScheduleInterview={onCloseScheduleInterviewHandler}
                    onScheduleInterviewSave={onScheduleInterviewSaveHandler}
                />
            ),
            size: ModalSize.LG,
            className: "model-min-height-500"
        };
        modalUtils.showPopup(config);
    };

    const onCloseScheduleInterviewHandler = () => {
        modalUtils.closeModal();
    };

    const onScheduleInterviewSaveHandler = (objScheduleInterview: ScheduleInterviewCompanyRequestModel) => {
        props.onScheduleInterview(objScheduleInterview);
    };

    const scheduleInterview = (row: AddProfilesGridModel) => {
        if (props.canScheduleInterviews) {
            modalUtils.showLoader();
            addProfilesService.getRequirementInterviewRounds(row.requirementId, row.profileId).then((res) => {
                modalUtils.closeModal();
                if (!res.isSuccess || res.errorMessages.length > 0) {
                    toasterUtils.showError(res.errorMessages.toString());
                    return;
                }
                if (res.items.length > 0) {
                    //if (row.addInterviewProcess) {
                    openInterviewRoundsModel(res.items, row);
                    // } else {
                    //     openScheduleInterviewModel(res.items[0], row);
                    // }
                }
            }).catch((error) => {
                modalUtils.closeModal();
                toasterUtils.showError(error);
            });
        } else {
            toasterUtils.showWarning("Cannot schedule Interview for this Requirement because either Calibration call not done or Client not approved or Panels not available.");
        }
    };

    const copyClipboard = (message: string) => {
        copyClickboardUtils.copy(message);
    };

    const columnsAddProfile = [
        { key: "CandidateName", text: "Candidate Name", sort: true, searchable: true },        
        { key: "InterviewDate", text: "Interview Date", sort: false, searchable: false },
        { key: "TotalRating", text: "Rating", sort: false, searchable: false },
        { key: "Comments", text: "Status", sort: false, searchable: false },
        { key: "Actions", text: "", sort: false, searchable: false }
    ];

    const viewHistory = (candidateId: string) => {
        props.onCandidateViewHistory(candidateId);
    };

    const createSortHandler = (property: string) => (event: React.MouseEvent) => {
        props.onSortAction(property, props.sortDirection === "asc" ? "desc" : "asc")
    };

    const handleChangePage = (event: any, newPage: number) => {
        props.onPageChangeAction(newPage);
    };

    const handleChangeRowsPerPage = (event: any) => {
        props.onPageSizeChangeAction(parseInt(event.target.value, 10));
    };

    const filterOnChange = (key: string, value: string) => {
        if (key === "CandidateName") {
            setCandidateNameFilter(value);
        } else {
            setStatusIdFilter(parseInt(value));
        }
        if ((value && value.length > 2) || value === "") {
            props.onFilterAction(key, value);
        }
    };

    const downloadCandidateResume = (candidateId: string, resumeTitle: string) => {
        if (loggedInUser) {
            modalUtils.showLoader();
            candidateService.downloadCandidateResume(candidateId, FileUploadTypeEnum.CandidateResume.toString()).then((res) => {
                modalUtils.closeModal();
                fileUtils.downloadFile(res, resumeTitle);
            }).catch((error) => {
                modalUtils.closeModal();
                toasterUtils.showError(error);
            });
        }
    };

    const viewRating = (row: AddProfilesGridModel) => {
        if (row.interviewId) {
            props.onViewRatingAction(row.interviewId);
        } else {
            toasterUtils.showWarning("No interview found to view rating.");
        }
    };

    return (
        <div className="row">
            <div className="col-md-12">
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell />
                                {columnsAddProfile.map((column: any) => (
                                    <TableCell key={column.key} className="table-header-cell">
                                        {column.sort &&
                                            <TableSortLabel
                                                active={props.sortColumn === column.key}
                                                direction={props.sortColumn === column.key ? props.sortDirection : "asc"}
                                                onClick={createSortHandler(column.key)}>
                                                {column.text}
                                            </TableSortLabel>
                                        }
                                        {column.searchable &&
                                            <input type="text" placeholder="search" className="mat-header-filter-input" value={candidateNameFilter}
                                                onClick={(e) => e.stopPropagation()} onChange={(e) => filterOnChange(column.key, e.target.value)}></input>
                                        }
                                        {!column.sort &&
                                            <span>{column.text}</span>
                                        }
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {props.addProfilesList.map((profile: AddProfilesGridModel, index) => (
                                <AddProfilesGridChildComponent
                                    key={index}
                                    candidate={profile}
                                    index={index}
                                    loggedInUser={loggedInUser}
                                    roleId={roleId}
                                    statusUpdate={statusUpdate}
                                    scheduleInterview={scheduleInterview}
                                    viewHistory={viewHistory}
                                    downloadCandidateResume={downloadCandidateResume}
                                    copyClipboard={copyClipboard}
                                    viewRating={viewRating}
                                />
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={props.pageSizesList}
                    component="div"
                    count={props.totalSize}
                    rowsPerPage={props.pagesize}
                    page={props.currentPage - 1}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </div>
        </div>
    );
};
export default AddProfilesGridComponent;